import { render, staticRenderFns } from "./ModelCustomerCustomRequestConfirm.vue?vue&type=template&id=2d24bafa"
import script from "./ModelCustomerCustomRequestConfirm.vue?vue&type=script&lang=js"
export * from "./ModelCustomerCustomRequestConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports